/**
 * Endpoints — page « Pointeuse » (pointages, absences et heures tirés de Teams).
 * Miroir front du contrat serveur : toutes les routes sont sous `/api/pointeuse`
 * et exigent le rôle complémentaire « pointeuse ».
 */

const periodQuery = ({ du, au }) => `?du=${du}&au=${au}`

export const pointeuseEndpoints = {
  etat: () => '/api/pointeuse/etat',
  actualiser: () => '/api/pointeuse/actualiser',
  periode: (range) => `/api/pointeuse/periode${periodQuery(range)}`,
  compteur: (range) => `/api/pointeuse/compteur${periodQuery(range)}`
}
